import { config } from '../config';

/**
 * Non-blocking beacon sender using sendBeacon with keepalive fetch fallback.
 * Useful for analytics and logging that shouldn't block the main thread or navigation.
 */
export function sendNonBlocking(endpoint: string, payload: unknown): void {
  try {
    const url = `${config.API_BASE_URL}${endpoint}`;
    const body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }

    // Fallback. keepalive prevents page-unload cancellation for small payloads
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      // Do not await in caller
    }).catch((err) => {
      console.error('[Analytics] fetch keepalive failed', err);
    });
  } catch (err) {
    console.error('[Analytics] sendNonBlocking failed', err);
  }
}



